import { Injectable, signal } from '@angular/core';

/**
 * Current map zoom level, written by MapComponent and read by the app shell's dev-only zoom
 * readout (see app.html, next to app-map-mode-toggle). Not persisted -- purely a live,
 * in-session debug aid for deciding tile zoom-range/coverage-layer tuning, not app state.
 */
@Injectable({ providedIn: 'root' })
export class MapZoomService {
  readonly zoom = signal<number | null>(null);
}
